import { useState } from 'react';
import toast from 'react-hot-toast';
import { ConfirmCreditsModal } from './ConfirmCreditsModal';

interface Props {
  // Feature de crédito cobrada por unidade (ex: listing_analysis, ads_campaign_analysis).
  featureKey: string;
  // Rótulo da unidade no modal (ex: "anúncio(s)", "campanha(s)").
  unitLabel: string;
  // Busca a quantidade real de itens que serão cobrados (com IA ativada + seleção do backend).
  estimate: () => Promise<number>;
  // Executa a ação de fato (rodar o agente) após confirmação.
  onRun: () => void;
  running?: boolean;
  disabled?: boolean;
  label: string;
  runningLabel?: string;
  className?: string;
  title?: string;
  note?: string;
}

/**
 * Botão que, ao ser clicado, estima quantos itens serão cobrados e abre o
 * ConfirmCreditsModal (mesmo estilo do "gerar conteúdo") pedindo confirmação
 * antes de rodar. Ex.: "Isso vai custar 4,50 créditos (30 anúncios × 0,15). Confirmar?"
 */
export function CreditConfirmRunButton({
  featureKey, unitLabel, estimate, onRun,
  running, disabled, label, runningLabel, className, title, note,
}: Props) {
  const [estimating, setEstimating] = useState(false);
  const [qty, setQty] = useState<number | null>(null);

  const openConfirm = async () => {
    setEstimating(true);
    try {
      const count = await estimate();
      setQty(Number.isFinite(count) ? count : 0);
    } catch {
      toast.error('Não foi possível estimar o custo. Tente novamente.');
    } finally {
      setEstimating(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={openConfirm}
        disabled={running || disabled || estimating}
        className={className}
      >
        {estimating ? 'Calculando...' : running ? (runningLabel || 'Rodando...') : label}
      </button>

      <ConfirmCreditsModal
        open={qty !== null}
        title={title || 'Confirmar execução'}
        items={qty !== null ? [{ featureKey, qty, label: unitLabel }] : []}
        note={note}
        confirmLabel="Confirmar e rodar"
        onConfirm={() => { const n = qty; setQty(null); if (n !== null) onRun(); }}
        onCancel={() => setQty(null)}
      />
    </>
  );
}
